"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSummaryContent = void 0;
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _useRecommendationStatus = require("../recommendation/useRecommendationStatus");
var _services = require("../../services");
var _useAppSelector = require("../useAppSelector");
const useSummaryContent = () => {
  const answers = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestionnaireAnswers);
  const summaries = answers.filter(answer => answer.summary).map(answer => {
    return {
      summary: answer.summary,
      id: answer.id
    };
  }).slice(0, 4);
  const {
    isJourneyForHandsetAndPlan,
    isJourneyForHandset,
    isJourneyForPlan
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  let summaryTitle;
  switch (true) {
    case isJourneyForHandsetAndPlan:
      summaryTitle = _services.locale.localeString('Summary.TitlePhoneAndPlan');
      break;
    case isJourneyForHandset:
      summaryTitle = _services.locale.localeString('Summary.TitlePhone');
      break;
    case isJourneyForPlan:
      summaryTitle = _services.locale.localeString('Summary.TitlePlan');
  }
  return {
    summaryTitle,
    summaries
  };
};
exports.useSummaryContent = useSummaryContent;